import { useEffect } from "react";
import { initLenis, destroyLenis, scrollToFormField } from "@/lib/scroll";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { OpeningBanner } from "@/components/landing/OpeningBanner";
import { Marquee } from "@/components/landing/Marquee";
import { SizesSection } from "@/components/landing/SizesSection";
import { BrandSection } from "@/components/landing/BrandSection";
import { PlanSection } from "@/components/landing/PlanSection";
import { LocationSection } from "@/components/landing/LocationSection";
import { ContactForm } from "@/components/landing/ContactForm";
import { FaqSection } from "@/components/landing/FaqSection";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFloat } from "@/components/landing/WhatsAppFloat";

export default function LandingPage() {
  useEffect(() => {
    initLenis();
    // Tráfico desde el QR de la lona: llevar directo al formulario de prerreserva.
    // El mapa y las imágenes tardan en cargar y desplazan el layout: reintentamos
    // hasta que el primer campo quede en posición (o el usuario haga scroll manual).
    const origen = new URLSearchParams(window.location.search).get("origen");
    if (!origen) return () => destroyLenis();

    let timer = null;
    let attempts = 0;
    let cancelled = false;
    const cancel = () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
    const tryScroll = () => {
      if (cancelled) return;
      attempts += 1;
      scrollToFormField();
      timer = setTimeout(() => {
        if (cancelled) return;
        const el = document.getElementById("cf-name");
        const top = el ? el.getBoundingClientRect().top : 9999;
        if ((top < 70 || top > 240) && attempts < 8) tryScroll();
      }, 1600);
    };
    timer = setTimeout(tryScroll, 1200);
    window.addEventListener("wheel", cancel, { passive: true, once: true });
    window.addEventListener("touchmove", cancel, { passive: true, once: true });
    return () => {
      cancel();
      window.removeEventListener("wheel", cancel);
      window.removeEventListener("touchmove", cancel);
      destroyLenis();
    };
  }, []);

  return (
    <div className="min-h-screen bg-brand-paper">
      <Header />
      <main>
        <Hero />
        <OpeningBanner />
        <Marquee />
        <SizesSection />
        <BrandSection />
        <PlanSection />
        <LocationSection />
        <ContactForm />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
